import { render } from "./demoPieChart.vue?vue&type=template&id=20477b7f&scoped=true"
import script from "./demoPieChart.vue?vue&type=script&lang=js"
export * from "./demoPieChart.vue?vue&type=script&lang=js"

import "./demoPieChart.vue?vue&type=style&index=0&id=20477b7f&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20477b7f"]])

export default __exports__